import type { SupDicChainData } from "@/hooks/api/useSupportedChains";
import type { ReadonlyURLSearchParams } from "next/dist/client/components/navigation";

export function getExplorerUrl(chainInfo: SupDicChainData | undefined, type: "tx" | "address" | "token", value?: string) {
  return chainInfo?.explorers[0] && value ? `${chainInfo?.explorers[0]}/${type}/${value}` : undefined;
}

export function getProtocolUrl(protocolId: string | undefined) {
  return protocolId ? `/protocol/${protocolId}` : undefined;
}

export function getVaultUrl(vaultId: string | undefined) {
  return vaultId ? `/vault/${vaultId}` : undefined;
}

export function getRewardsUrl(path: string, searchParams: ReadonlyURLSearchParams) {
  return `${path}${searchParams.size > 0 ? `?${searchParams}` : ""}`;
}
